import React from 'react'
import Intro from '../../components/Intro'

const IntroPage = () => {
  return (
    <> 
       < Intro />
    </>
  )
}

export default IntroPage